// extracted by mini-css-extract-plugin
module.exports = {"link":"Logo_link__Uw6PJ","logo":"Logo_logo__1LzU4"};